import { traceabilitiesTypes } from './actionTypes';

export type GetTraceabilityByWrNumberPayload = {
  pagination: { sizePerPage: number; page: number };
  filters?: { from: String; to: String; dynamicFilter: String; order?: String };
};

export type GetTraceabilityFiltersPayload = {
  filters?: { from?: String; to?: String };
};

export const getTraceability = (payload: GetTraceabilityByWrNumberPayload) => {
  return {
    type: traceabilitiesTypes.GET_FILTER_LIST,
    payload,
  };
};
export const getTraceabilityFilters = (payload: GetTraceabilityFiltersPayload = {}) => {
  return {
    type: traceabilitiesTypes.GET_FILTERS,
    payload,
  };
};
export const getTraceabilitySuccess = (payload: any) => {
  return {
    type: traceabilitiesTypes.GET_FILTER_LIST_SUCCESS,
    payload,
  };
};
export const getTraceabilityFiltersSuccess = (payload: any) => {
  return {
    type: traceabilitiesTypes.GET_FILTERS_SUCCESS,
    payload,
  };
};
export const getTraceabilityError = (error: any) => {
  return {
    type: traceabilitiesTypes.GET_FILTER_LIST_ERROR,
    payload: error,
  };
};
export const getFilterListWrNumber = (WRNUMBER: any) => {
  return {
    type: traceabilitiesTypes.GET_FILTER_LIST_WRNUMBER,
    payload: { WRNUMBER },
  };
};
export const getTraceabilitiesFilters = (WRNUMBER: any) => {
  return {
    type: traceabilitiesTypes.GET_FILTER_LIST_WRNUMBER,
    payload: { WRNUMBER },
  };
};

export const getFilterListSuccessWrNumber = (payload: any) => ({
  type: traceabilitiesTypes.GET_FILTER_LIST_SUCCESS_WRNUMBER,
  payload,
});

export const getFilterListFailWrNumber = (error: any) => ({
  type: traceabilitiesTypes.GET_FILTER_LIST_FAIL_WRNUMBER,
  payload: error,
});
